<template>
  <v-container fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <cpn-lead-form></cpn-lead-form>
        <cpnLeadEconomy :lead="lead" />
      </v-flex>
      <!-- <v-flex
                xs12
                md12
            >
                <cpn-lead-proposal-list></cpn-lead-proposal-list>
            </v-flex> -->
      <!-- <v-flex
                xs12
                md12
            >
                <cpn-lead-form-proposal :proposal="proposal"></cpn-lead-form-proposal>
            </v-flex> -->
    </v-layout>
    <!--
        <v-flex
        xs12
        md12
        >
            <cpn-lead-list :leads="leads"></cpn-lead-list>
        </v-flex>
        -->
  </v-container>
</template>
<script>
// import LeadList from '../components/lead/LeadList'
import LeadForm from "../components/lead/LeadForm";
// import LeadUpload from '../components/lead/LeadUpload'
// import LeadFormProposal from '../components/lead/LeadFormProposal'

// import { getLead } from '../services/leads'
import { eventBus } from "../main";
// import LeadProposalList from '../components/lead/LeadProposalList.vue'
import LeadEconomy from "../components/Economy";
// import { GET_LEAD } from '../graphql/leads'
import { getLead } from "../services/leads";

export default {
  data: function () {
    return {
      // leads: [],
      id: "",
      lead: {},
      proposal: {},
      loading: false,
    };
  },
  components: {
    // cpnLeadList: LeadList,
    cpnLeadForm: LeadForm,
    // cpnLeadProposalList: LeadProposalList,
    // cpnLeadFormProposal: LeadFormProposal,
    cpnLeadEconomy: LeadEconomy,
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.fecthLead(this.id);
    }
  },
  methods: {
    async fecthLead(id) {
      this.loading = true;
      getLead(id)
        .then((_lead) => {
          this.lead = {
            id: _lead.id,
            ..._lead.data(),
          };
          eventBus.$emit("leadSelected", this.lead);
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
};
</script>
